import React from 'react';

export function ButtonGrid({ rows, cols, children }) {
  const gridStyles = {
    display: 'grid',
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
  };
  return (
    <div className="chronos-button-grid" style={gridStyles}>
      {children}
    </div>
  );
}
